<template>
  <div class="main index" v-if="!isLoading">
    <div class="columns is-multiline">
      <div class="column is-12">
        <h1 class="is-size-3"><b>Case Study Report</b></h1>
      </div>
      <div class="column bar">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li>
              <h3 class="is-size-6">Case Study</h3>
            </li>
            <li>
              <h3 class="is-size-6 breadcrumb-item">Case study Report</h3>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column is-1">Filter by</div>
        <div class="column is-3">
          <b-select
            placeholder="NIT, UID, Assessment Title, Name"
            v-model="filter"
            expanded
          >
            <option value="nit">NIT</option>
            <option value="uid">UID</option>
            <option value="page_title">Case Study Title</option>
            <option value="name">Name</option>
          </b-select>
        </div>
        <div class="column is-narrow">Keyword</div>
        <div class="column is-3">
          <b-field>
            <b-input v-model="search" type="search"></b-input>
          </b-field>
        </div>
        <div class="column is-narrow">
          <b-button type="is-hcc" @click="searchReport(search)">
            Filter
          </b-button>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <!-- <div class="box"> -->
          <b-table
            :data="
              getCaseStudyReports && getCaseStudyReports.data
                ? getCaseStudyReports.data
                : []
            "
            :current-page.sync="currentPage"
            paginated
            backend-pagination
            :loading="tableLoading"
            :total="
              getCaseStudyReports && getCaseStudyReports.total
                ? getCaseStudyReports.total
                : 0
            "
            :per-page="perPage"
            @page-change="onPageChange"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            backend-sorting
            :default-sort-direction="defaultSortOrder"
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"
          >
            <b-table-column
              field="case_study_answers.nit"
              label="NIT"
              sortable
              v-slot="props"
            >
              {{ props.row.nit }}
            </b-table-column>
            <b-table-column
              field="case_study_answers.uid"
              label="UID"
              sortable
              v-slot="props"
            >
              {{ props.row.uid }}
            </b-table-column>
            <b-table-column
              field="case_studies.page_title"
              label="Case Study Title"
              sortable
              v-slot="props"
            >
              {{ props.row.pageTitle }}
            </b-table-column>
            <b-table-column
              field="case_study_answers.name"
              label="Name"
              sortable
              v-slot="props"
            >
              {{ props.row.name }}
            </b-table-column>
            <b-table-column
              field="case_study_answers.finish_status"
              label="Finished?"
              sortable
              v-slot="props"
            >
              {{ props.row.finishStatus }}
            </b-table-column>
            <b-table-column
              field="case_study_answers.reload_frequency"
              label="Freq Reload (times)"
              sortable
              numeric
              width="150"
              v-slot="props"
            >
              {{ props.row.reloadFrequency }}
            </b-table-column>
            <b-table-column
              field="case_study_answers.submitted_at"
              label="Submitted At"
              sortable
              numeric
              v-slot="props"
            >
              {{ props.row.submittedAt }}
            </b-table-column>
            <b-table-column
              field="action"
              label
              sortable
              centered
              width="100"
              v-slot="props"
            >
              <b-button
                type="icon-button"
                icon-left="paper-plane"
                @click="
                  sendReport(
                    props.row.nit,
                    props.row.name,
                    props.row.email,
                    props.row.cid,
                    props.row.uid,
                    props.row.caseStudyId,
                    props.row.idTes,
                    props.row.appUrl
                  )
                "
              ></b-button>
              <b-button
                type="icon-button"
                icon-left="eye"
                @click="detailReport(props.row.id)"
              ></b-button>
            </b-table-column>
            <template slot="bottom-left">
              {{
                getCaseStudyReports && getCaseStudyReports.from
                  ? getCaseStudyReports.from
                  : 0
              }}
              -
              {{
                getCaseStudyReports && getCaseStudyReports.to
                  ? getCaseStudyReports.to
                  : 0
              }}
              from
              {{
                getCaseStudyReports && getCaseStudyReports.total
                  ? getCaseStudyReports.total
                  : 0
              }}
            </template>
            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="frown" size="is-large"></b-icon>
                  </p>
                  <p>Data not found.</p>
                </div>
              </section>
            </template>
          </b-table>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      isFullPage: true,
      isLoading: false,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      defaultSortDirection: 'desc',
      defaultSortOrder: 'desc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      currentPage: 1,
      perPage: 10,
      activeTab: 0,
      sortField: 'id',
      sortOrder: 'desc',
      page: 1,
      filter: null,
      search: null,
      tableLoading: false,
    }
  },
  mounted() {
    this.fetchData(this.perPage, this.currentPage)
  },
  watch: {
    // search: function(val) {
    //   this.searchReport(val);
    // }
  },
  methods: {
    detailReport(id) {
      this.$router.push({ path: `/case-study-report/show/${id}` })
    },
    searchReport(value) {
      if (value) {
        this.search = value
        this.fetchData(
          this.perPage,
          this.page,
          this.sortField,
          this.sortOrder,
          this.search,
          this.filter
        )
      } else {
        this.search = null
        this.fetchData(
          this.perPage,
          this.page,
          this.sortField,
          this.sortOrder,
          this.search,
          this.filter
        )
      }
    },
    async exportPDF() {
      const loadingComponent = this.$buefy.loading.open({
        container: this.isFullPage ? null : this.$refs.element.$el,
      })
      await this.$store.dispatch('exportPDF')
      loadingComponent.close()
    },
    async exportCSV() {
      const loadingComponent = this.$buefy.loading.open({
        container: this.isFullPage ? null : this.$refs.element.$el,
      })
      await this.$store.dispatch('exportCSV')
      loadingComponent.close()
    },
    importExcel() {
      this.$store
        .dispatch('importExcel', this.file)
        .then(() => {
          this.success('Successfully import excel')
        })
        .catch(() => {
          this.danger('Failed to import excel')
        })
    },
    exportExcel() {
      this.$store.dispatch('exportExcel')
    },
    async fetchData(perPage, page, sortField, sortOrder, search, filter) {
      this.tableLoading = true
      await this.$store.dispatch('getCaseStudyReports', {
        perPage,
        page,
        sortField,
        sortOrder,
        search,
        filter,
      })
      this.tableLoading = false
    },
    onPageChange(page) {
      this.currentPage = page
      this.page = page
      this.fetchData(
        this.perPage,
        this.page,
        this.sortField,
        this.sortOrder,
        this.search,
        this.filter
      )
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order
      this.fetchData(
        this.perPage,
        this.page,
        this.sortField,
        this.sortOrder,
        this.search,
        this.filter
      )
    },
    sendReport(nit, nama, email, cid, uid, caseStudyId, idTes, appUrl) {
      this.$store
        .dispatch('getDataToSendCaseStudy', {
          nit: nit,
          nama: nama,
          email: email,
          cid: cid,
          uid: uid,
          case_study_id: caseStudyId,
          id_tes: idTes,
          app_url: appUrl,
        })
        .then(() => {
          this.success('Data berhasil dikirimkan')
        })
        .catch(() => {
          this.danger('Data gagal dikirimkan')
        })
    },

    // For success alert
    success(message) {
      this.$buefy.toast.open({
        message: message,
        type: 'is-success',
      })
    },

    // For danger/error alert
    danger(message) {
      this.$buefy.toast.open({
        message: message,
        type: 'is-danger',
      })
    },
  },
  computed: {
    ...mapGetters(['getCaseStudyReports']),
  },
}
</script>

<style lang="scss">
@media (min-width: 1024px) and (max-width: 1200px) {
  .p-1 {
    padding-right: 2em !important;
  }
}
.btn-import {
  width: 130px;
}
.space {
  margin-right: 10px;
}
.pdf {
  color: #ff0000;
}
.button-action {
  border: none !important;
  color: #00a3a3;
}
</style>
